/** เลือกอวตารจากชุดสำเร็จรูป — รายชื่ออยู่ที่ `@/lib/avatars` */
import { AVATARS } from '@/lib/avatars'

interface Props {
  value: string
  onChange: (key: string) => void
}

export function AvatarPicker({ value, onChange }: Props): JSX.Element {
  return (
    <div className="avatars">
      {Object.entries(AVATARS).map(([key, glyph]) => (
        <button
          key={key}
          type="button"
          className={`avatar${value === key ? ' is-on' : ''}`}
          aria-pressed={value === key}
          aria-label={key}
          onClick={() => onChange(key)}
        >
          {glyph}
        </button>
      ))}
    </div>
  )
}
